import { yupResolver } from "@hookform/resolvers/yup";
import { useEffect, useState } from "react";
import { Alert, Button, Col, Container, Form, Row } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { ConsultarPessoa } from "src/hook/Consulta/ConsultaPessoa.Module";
import { PessoaDto } from "src/pages/Privada/Entidade/Pessoa/Pessoa.Dto";
import yup from "src/validators/yup.Module";
import {
  getLocal,
  NFeDto,
  NFeCadastroTransporteDto,
  STORAGENFE_KEY,
  updateLocal,
} from "../NFe.Dto";
import { DropdownFilter, FloatInput } from "src/componentes";
import PessoaCadastroView from "src/pages/Privada/Entidade/Pessoa/Cadastro/PessoaCadastro.View";
import { validatePlaca } from "src/validators/validatePlaca";
import { validateUF } from "validations-br";

const NFeCadastroTransporteView = () => {
  const navigate = useNavigate();
  const [cadastro, setCadastro] = useState<boolean>(false);
  const pessoaBuscar = ConsultarPessoa();
  const nf = getLocal<NFeDto>(STORAGENFE_KEY);
  const transporte = nf?.transporte;
  const exigeDados = transporte?.modalidadeFrete !== 9;

  const TransporteSchema = yup.object().shape({
    id: exigeDados
      ? yup
          .number()
          .min(1, "Selecione uma pessoa")
          .required("Selecione uma pessoa")
      : yup.number().notRequired(),

    placa: exigeDados
      ? yup
          .string()
          .required("Placa obrigatória.")
          .test("placa-br", "Placa inválida.", (value) => validatePlaca(value))
      : yup.string().notRequired(),

    placaUF: exigeDados
      ? yup
          .string()
          .required("UF é obrigatório.")
          .test("uf", "UF inválido.", (value) => validateUF(value))
      : yup.string().notRequired(),
  });

  const form = useForm<NFeCadastroTransporteDto>({
    resolver: yupResolver(TransporteSchema),
    defaultValues: { ...transporte },
  });

  const id = form.getValues("id");

  const handleVoltar = () => () => {
    navigate("../modalidadefrete");
  };

  const handleSuccess = (value: PessoaDto) => {
    form.reset(value);
    setCadastro(false);
  };

  const handleCancel = () => {
    setCadastro(false);
  };

  const onSubmit = async (data: NFeCadastroTransporteDto, e: any) => {
    updateLocal<NFeDto>(STORAGENFE_KEY, {
      transporte: data,
    });
    navigate("../volumes");
  };

  if (cadastro) {
    return (
      <Row>
        <PessoaCadastroView
          onSuccess={handleSuccess}
          onCancel={handleCancel}
          initialValue={transporte ? form.getValues() : undefined}
        />
      </Row>
    );
  }

  return (
    <>
      <Form noValidate onSubmit={form.handleSubmit(onSubmit)}>
        {exigeDados ? (
          <>
            <Row>
              <Col xs={12}>
                <DropdownFilter<PessoaDto>
                  fetchData={pessoaBuscar.PessoaBuscar}
                  loading={pessoaBuscar.loading}
                  labelDescription="Transporte"
                  getDescription={(item: PessoaDto) => item.nome}
                  getId={(item: PessoaDto) => item.id}
                  registeredFields={{
                    id: form.register("id"),
                    description: form.register("nome"),
                  }}
                  errorsMessageDescription={form.formState.errors.id}
                  onSelect={(item: PessoaDto | undefined) => {
                    if (item !== undefined) {
                      form.reset({
                        ...transporte,
                        ...item,
                      });
                    } else {
                      form.reset(
                        {},
                        {
                          keepDefaultValues: false,
                        }
                      );

                      form.setValue(
                        "modalidadeFrete",
                        transporte?.modalidadeFrete
                      );
                    }
                  }}
                ></DropdownFilter>
              </Col>

              {id > 0 ? (
                <Col>
                  <Button variant="link" onClick={() => setCadastro(true)}>
                    Alterar
                  </Button>
                </Col>
              ) : (
                <Col>
                  <Button variant="link" onClick={() => setCadastro(true)}>
                    Novo
                  </Button>
                </Col>
              )}
            </Row>
            {id > 0 && (
              <>
                <Row>
                  <Col xs={12} md={4}>
                    <FloatInput
                      label="Documento"
                      registerField={form.register("documento")}
                      readOnly={true}
                    />
                  </Col>
                  <Col xs={9} md={6}>
                    <FloatInput
                      label="Município"
                      registerField={form.register("nomeMunicipio")}
                      readOnly={true}
                    />
                  </Col>
                  <Col xs={3} md={2}>
                    <FloatInput
                      label="UF"
                      registerField={form.register("uf")}
                      readOnly={true}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col xs={12} md={10}>
                    <FloatInput
                      label="Placa do Veículo"
                      inputMask="maiusculas"
                      registerField={form.register("placa")}
                      errorsMessage={form.formState.errors.placa}
                    />
                  </Col>
                  <Col xs={12} md={2}>
                    <FloatInput
                      label="UF da Placa"
                      maxLength={2}
                      inputMask="maiusculas"
                      registerField={form.register("placaUF")}
                      errorsMessage={form.formState.errors.placaUF}
                    />
                  </Col>
                </Row>
              </>
            )}
          </>
        ) : (
          <Alert variant="warning">
            Modalidade de frete <strong>Sem Ocorrência de Transporte</strong>,
            não deve informar dados de transporte.
          </Alert>
        )}
        <div className="fixed-bottom">
          <Container className="py-3">
            <Row>
              <Col xs={6} className="d-grid">
                <Button variant="outline-secondary" onClick={handleVoltar()}>
                  Voltar
                </Button>
              </Col>
              <Col xs={6} className="d-grid">
                <Button variant="outline-primary" type="submit">
                  Próximo
                </Button>
              </Col>
            </Row>
          </Container>
        </div>
      </Form>
    </>
  );
};
export default NFeCadastroTransporteView;
